import type { SendFeedbackInput } from "@repo/shared";

import { API_V1_PREFIX, apiRequest } from "../api-client";

export async function sendFeedback(input: SendFeedbackInput): Promise<void> {
  await apiRequest({
    path: `${API_V1_PREFIX}/feedback`,
    method: "POST",
    body: input,
  });
}
